import {charcoal} from '../sass/base/_exports.sass';

export const MinusIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.333374 14.6667H25.3334V17.3333H6.66669V14.6667Z" fill={color} />
    </svg>
  );
};
